module.exports = __webpack_public_path__ + "img/setting.de699c5f.svg";